import React, { useState } from 'react';
import integrationService from '../../services/api/integrationService';

export default function CredentialHandover({ client, onCreated }) {
  const [review, setReview] = useState(false);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const replace = async () => {
    setBusy(true); setError('');
    try {
      const created = await integrationService.replaceCredential(client.id, { expectedUpdatedAt: client.updatedAt, reason });
      // The containing page owns the one-time secret display so refreshing
      // the now-revoked row cannot unmount and lose the newly generated key.
      await onCreated(created);
      setReview(false); setReason('');
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  if (client.handoverEnabled !== true) return <span>Credential replacement awaits deployment verification.</span>;
  if (!review) return <button type="button" onClick={() => setReview(true)}>Replace credential</button>;
  return <fieldset style={{ minWidth: 260 }}>
    <legend>Review credential replacement — {client.name}</legend>
    <p>The replacement keeps this integration authority and its financial history. The current key stops working when you confirm. Store the new key and configure it in the caller.</p>
    <p>Use the permission editor to change grants while keeping the same key.</p>
    <dl>
      <dt>Principal</dt><dd>{client.principalId || `Isolated credential ${client.id}`}</dd>
      <dt>Permissions</dt><dd>{(client.scopes || []).join(', ')}</dd>
      <dt>Source systems</dt><dd>{(client.financialAccess?.sourceSystems || []).join(', ') || 'None'}</dd>
      <dt>Legal employers</dt><dd>{(client.financialAccess?.employerCvrs || []).join(', ') || 'None'}</dd>
    </dl>
    <label>Review reason<input value={reason} maxLength={500} disabled={busy} onChange={event => setReason(event.target.value)} /></label>
    {error && <p role="alert">{error}</p>}
    <button type="button" disabled={busy || reason.trim().length < 10} onClick={replace}>Replace and revoke current key</button>{' '}
    <button type="button" disabled={busy} onClick={() => setReview(false)}>Cancel</button>
  </fieldset>;
}
